module.exports = __webpack_public_path__ + "static/media/tycl-hd.63031c47.png";